/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Login__SubtitleInputs */

const en_auth__login__subtitle = /** @type {(inputs: Auth__Login__SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome back! Please enter your details.`)
};

/**
* | output |
* | --- |
* | "Welcome back! Please enter your details." |
*
* @param {Auth__Login__SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__login__subtitle = /** @type {((inputs?: Auth__Login__SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Login__SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__login__subtitle(inputs)
});